import { ExamGroup } from "../exam-group/exam-group";

export class ExamTemplate {
  constructor(
    public id?: number,
    public name?: string,
    public description?: string,
    public exam_group?: ExamGroup,
    public user?: any
  ) {}
}